import { TFunction } from "react-i18next";
import { AxiosError } from "axios";

import { UseToast } from "@hooks";
import { Error, IError } from "@utils";

export function handleError(
  axiosError: unknown,
  toast: UseToast,
  t: TFunction<"translation", undefined>
) {
  const error = axiosError as AxiosError<IError>;

  if (error.response) {
    const { code, detail, errors } = error.response.data;
    toast({
      code,
      detail,
      errors,
    });
  } else {
    toast({
      code: Error.Backend,
      detail: t("errors.generic.title"),
      errors: [{ detail: t("errors.generic.description") }],
    });
  }
}
